import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from '@zillow/constellation';
import { applicantStatusTypes } from '../../../../../constants/statusConstants';
import ClampedText from '../../../../../components/ClampedText';
import { Link as ScrollLink } from 'react-scroll';
import { getHeaderStatusText } from './Applicant.util';
import { getTitleCase } from '../../../../../utils/formatLogicUtil';

export default function Applicant({ submittedDateTime, name, status, scrollLinkKey, className }) {
  return (
    <Flex display="flex" flexDirection="column" alignItems={{ default: 'center', md: 'normal' }} className={className}>
      <ClampedText maxLines={2} fontType={{ default: 'h6', lg: 'h5' }} as="h3">
        <ScrollLink to={scrollLinkKey}>{getTitleCase(name)}</ScrollLink>
      </ClampedText>
      <Text>
        {getHeaderStatusText({
          isNotStarted: status === applicantStatusTypes.INVITED.id,
          isComplete: status === applicantStatusTypes.COMPLETED.id,
          submittedDate: submittedDateTime,
        })}
      </Text>
    </Flex>
  );
}

Applicant.propTypes = {
  className: PropTypes.string,
  scrollLinkKey: PropTypes.string,
  name: PropTypes.string,
  status: PropTypes.string,
  submittedDateTime: PropTypes.string,
};
